import { Controller, SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  Modal,
  Switch,
  TextField,
} from "@heroui/react";
import { Icon } from "@iconify/react";
import { useState } from "react";

import { useCreateTariffCategory } from "@/features/tariffs/use-tariffs.ts";

interface IFormInput {
  name: string;
  key: string;
  active: boolean;
}

export function CreateTariffCategoryModal() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { mutateAsync, isPending } = useCreateTariffCategory({
    onSuccess: () => {
      reset();
      setIsOpen(false);
    },
  });

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) =>
    mutateAsync({
      name: data.name.trim(),
      key: data.key.trim(),
      active: data.active,
      sortIndex: 0,
    });

  return (
    <>
      <Button
        variant="primary"
        onPress={() => setIsOpen(true)}
      >
        Создать категорию
        <Icon className="size-6" icon="solar:add-circle-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center" size="lg">
            <Modal.Dialog>
              <Form
                  className="flex flex-col pt-4 pr-4"
                  onSubmit={handleSubmit(onSubmit)}
              >
                <Modal.Header>
                  <Modal.Heading>Создать новую категорию тарифов</Modal.Heading>
                </Modal.Header>

                <Modal.Body>
                  <TextField isInvalid={!!errors.name?.message}>
                    <Label>Название</Label>
                    <Input {...register("name", { required: "Нужно заполнить поле" })} />
                    <FieldError>{errors.name?.message}</FieldError>
                  </TextField>

                  <TextField isInvalid={!!errors.key?.message}>
                    <Label>Ключ переводов</Label>
                    <Input {...register("key", { required: "Нужно заполнить поле" })} />
                    <FieldError>{errors.key?.message}</FieldError>
                  </TextField>

                  <Controller
                      control={control}
                      name="active"
                      defaultValue={true}
                      render={({ field }) => (
                          <Switch isSelected={field.value} onChange={field.onChange}>
                            <Switch.Control>
                              <Switch.Thumb />
                            </Switch.Control>
                            <Switch.Content>
                              <Label>Активная</Label>
                            </Switch.Content>
                          </Switch>
                      )}
                  />
                </Modal.Body>

                <Modal.Footer>
                  <Button
                      variant="danger-soft"
                      onPress={() => setIsOpen(false)}
                  >
                    Отмена
                  </Button>

                  <Button variant="primary" isPending={isPending} type="submit">
                    Создать
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </>
  );
}
